export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    if (typeof exdays == 'today') {
        var d = new Date();
        d.setHours(23, 59, 59, 0);
    }else if( typeof exdays === 'string' ){
        let res = checkInputExdays( exdays )
        let time = res ? res.hr : 1
        d.setTime( d.getTime() + time*60*60*1000 );
    }else {
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
    }
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const checkInputExdays = ( exdays ) => {
    let patt = /^([0-9]*)(hr)$/gi
    let result = patt.exec( exdays )
    return result ? {'hr': Number(result[1]) , unit: result[2] } : null
}

export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}
export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export function setFormatEmptyValue( data , format = '-' ) {
    let keys = Object.keys( data )
    keys.forEach( function(key){
        if( data[key] != null && typeof data[key] === 'object' ){
            setFormatEmptyValue( data[key] )
        }else if( data[key] == null || data[key] === "" || data[key] === 0 ){
            data[key] = format
        }
    })
    return data
}

export function numberFormat( number , format = ',' ) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, format)
}

export function formatNumberBank(num) {
    const number = num.toString()
    const pattern = /^\d{3}-\d{1}-\d{5}-\d{1}$/;
    if (pattern.test(number)) {
        return number;
    }
    return number.slice(0, 3) + "-" + number[3] + "-" + number.slice(4, 9) + "-" + number[9];
}
